// Copyright The Perses Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export interface TimeZoneOption {
  value: string;
  display: string;
}

/**
 * Get all available timezone options
 * @returns Array of timezone options
 */
export function getTimeZoneOptions(): TimeZoneOption[] {
  const native =
    (Intl as unknown as { supportedValuesOf?: (k: string) => string[] }).supportedValuesOf?.('timeZone') ?? [];
  const values = ['local', 'UTC', ...native].filter((v, i, arr) => arr.indexOf(v) === i);
  return values.map((value) => ({ value, display: value === 'local' ? 'Local' : value.replace(/_/g, ' ') }));
}
